import { render, staticRenderFns } from "./admin-account.vue?vue&type=template&id=3a791054&"
import script from "./admin-account.vue?vue&type=script&lang=js&"
export * from "./admin-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports